module.exports = __webpack_public_path__ + "img/Norfolk Island.c85595f4.svg";